

export default class conditionsAggregator {
    fields:any;
    conditionFields:Array<any>
    conditions:Array<any>;
    fieldValues:Array<string>;
    constructor(fields:any)
    {
        this.fields = fields;
        this.fieldValues = [];
        this.conditionFields = [];
        this.conditions = [];
        this.aggrigate();
    }

    buildConditions = (fieldConditions):void => {

        fieldConditions.map((fieldItem) => {

            //if item is the part of condition
            fieldItem.conditions.map((conditionItem) => {
                if(this.conditionFields?.indexOf(conditionItem.fieldId) < 0)
                {
                    this.conditionFields.push(conditionItem.fieldId);
                }
            }); 
            
            //if item is part of action
            fieldItem.actions.map((actionItem) => {
                if(this.conditionFields?.indexOf(actionItem.fieldId) < 0)
                {
                    this.conditionFields.push(actionItem.fieldId);
                }

                    //add and arrange all conditions against a certain "action" item
                    // check if that action has been defined first - then either create it or add the condition to it.
                        if (typeof this.conditions[actionItem.fieldId] === 'undefined')
                        {
                                this.conditions[actionItem.fieldId] = [
                                {
                                    matchTypeId: fieldItem.matchTypeId,
                                    conditions: fieldItem.conditions,
                                    actionTypeId: actionItem.actionTypeId
                                } 
                            ]
                        }
                        else
                        {
                            this.conditions[actionItem.fieldId].push({
                                matchTypeId: fieldItem.matchTypeId,
                                conditions: fieldItem.conditions,
                                actionTypeId: actionItem.actionTypeId
                            } )
                        }
                });
            });
        };

    aggrigate():void {
        this.fields.map((item) => {
            //add all items that are part of a condition or the target of an action
                  if(item.model.conditionSettings.fieldConditions.length > 0)
                  {
                    this.buildConditions(item.model.conditionSettings.fieldConditions);
                    this.fieldValues[item.model.conditionSettings.fieldKey] = item.model.value;
                  }
                  else
                  {
                        if(item?.fields !== undefined)
                        {
                            //item?.fields[0]
                            for(let i=0;i < item.fields.length;i++)
                            {
                                this.buildConditions(item.fields[i].model.conditionSettings.fieldConditions);
                                // if(item.fields[i].model.conditionSettings.fieldConditions.length > 0)
                                // {
                                    this.fieldValues[item.fields[i].model.conditionSettings.fieldKey] = item.fields[i].model.value;  
                                //}
                            }
                        }
                  }

            
             
            //add all field values to the form
            
        });

    }



}